module.exports = __webpack_public_path__ + "static/media/icon-bell-white.9a5b69cf.svg";